import * as gs from './_csGbl'; // server 適用外
export const grtUz = () => {
  const _gUserz = gs.useUserz();
  return {
    _dmn: _gUserz.crt?._dmn,
    _who: _gUserz.crt?._10rz?._key,
  }
};